exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.back-to-ceiling[data-v-787a82f6] {\n  position: fixed;\n  display: inline-block;\n  text-align: center;\n  cursor: pointer;\n}\n.back-to-ceiling[data-v-787a82f6]:hover {\n  background: #d5dbe7;\n}\n.fade-enter-active[data-v-787a82f6],\n.fade-leave-active[data-v-787a82f6] {\n  -webkit-transition: opacity .5s;\n  transition: opacity .5s;\n}\n.fade-enter[data-v-787a82f6],\n.fade-leave-to[data-v-787a82f6] {\n  opacity: 0\n}\n.back-to-ceiling .Icon[data-v-787a82f6] {\n  fill: #9aaabf;\n  background: none;\n}\n", ""]);

// exports
